import { HttpClient } from '../../httpClient/index.ts'
import { IPaginatedAssessmentsResponse } from './interfaces.ts'

export interface IPaginatedAssessmentFilters {
	assessmentType?: string
	employeeUserId?: string
	managerUserId?: string
	includes?: string[]
	limit?: number
	offset?: number
}

export const getPaginatedAssessments = async (
	client: HttpClient,
	filters?: IPaginatedAssessmentFilters
): Promise<IPaginatedAssessmentsResponse> => {
	const response = await client.get<IPaginatedAssessmentsResponse>('/api/v2/paginatedAssessments', {
		params: {
			...filters,
			includes: filters?.includes?.join(','),
		},
	})

	return response.data
}
